import { graphql } from "babel-plugin-relay/macro";
import { useCallback, useContext } from "react";
import { useMutation } from "react-relay";
import {
  useSyncAppleDeveloperAgreementsMutation$data,
  useSyncAppleDeveloperAgreementsMutation as useSyncAppleDeveloperAgreementsMutationType,
} from "./__generated__/useSyncAppleDeveloperAgreementsMutation.graphql";
import SnackbarContext from "../contexts/SnackbarContext";

const mutation = graphql`
  mutation useSyncAppleDeveloperAgreementsMutation($brandId: ID!) {
    syncAppleDeveloperAgreements(brandId: $brandId) {
      ... on BrandType {
        id
        appleDeveloperAgreementsPendingSince
        showIosTosAlert
      }
    }
  }
`;

const useSyncAppleDeveloperAgreementsMutation = (
  brandID: string
): [
  (
    onCompleted?: (data: useSyncAppleDeveloperAgreementsMutation$data) => void
  ) => void,
  boolean
] => {
  const [syncMutation, isMutationInFlight] =
    useMutation<useSyncAppleDeveloperAgreementsMutationType>(mutation);
  const snackbarContext = useContext(SnackbarContext);

  const onMutate = useCallback(
    (
      onCompleted?: (data: useSyncAppleDeveloperAgreementsMutation$data) => void
    ) => {
      syncMutation({
        variables: {
          brandId: brandID,
        },
        onCompleted: (data, errors) => {
          if (errors) {
            snackbarContext?.openSnackbar("Sync failed", "error");
          } else {
            onCompleted && onCompleted(data);
            snackbarContext?.openSnackbar(
              "Apple developer agreements synced",
              "success"
            );
          }
        },
        onError: (error: Error) => {
          snackbarContext?.openSnackbar("Sync failed", "error");
        },
      });
    },
    [snackbarContext, syncMutation, brandID]
  );

  return [onMutate, isMutationInFlight];
};

export default useSyncAppleDeveloperAgreementsMutation;
